<template>
  <v-row no-gutters>
    <v-col v-if="params.context.parentComponent.permissions.view">
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <SecondaryButton
            @click="view"
            x-small
            v-on="on"
            v-bind="attrs"
            btnClass="mr-2 rounded"
            icon="mdi-eye"
            iconClass=""
          >
          </SecondaryButton>
        </template>
        <span>View</span>
      </v-tooltip>
    </v-col>
    <v-col v-if="params.context.parentComponent.permissions.change">
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <PrimaryButton
            @click="editItem"
            x-small
            v-on="on"
            v-bind="attrs"
            btnClass="mr-2 rounded"
            icon="mdi-pencil"
            iconClass=""
          >
          </PrimaryButton>
        </template>
        <span>Edit</span>
      </v-tooltip>
    </v-col>
    <v-col
      v-if="params.context.parentComponent.permissions.change"
      class="switch-font-size"
    >
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-icon
            v-if="
              params.data.status == 'on_duty' ||
              params.data.status == 'off_duty'
            "
            v-bind="attrs"
            v-on="on"
            large
            class="ma-0"
            :color="params.data.is_active ? 'green' : 'grey'"
            @click="vehicleStatusChanged"
            >{{
              params.data.is_active
                ? "mdi-toggle-switch"
                : "mdi-toggle-switch-off"
            }}
          </v-icon>
          <v-icon v-else v-bind="attrs" v-on="on" large color="grey"
            >{{
              params.data.is_active
                ? "mdi-toggle-switch"
                : "mdi-toggle-switch-off"
            }}
          </v-icon>
        </template>
        <span> Update Vehicle Status </span>
      </v-tooltip>
    </v-col>
    <v-col>
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <ErrorButton
            @click="addTag"
            x-small
            v-on="on"
            v-bind="attrs"
            btnClass="mr-2 rounded"
            icon="mdi-tag"
            iconClass=""
          >
          </ErrorButton>
        </template>
        <span>Add Tags</span>
      </v-tooltip>
    </v-col>
    <v-col v-if="params.context.parentComponent.permissions.view">
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <WarningButton
            @click="getDocumentList"
            x-small
            v-on="on"
            v-bind="attrs"
            btnClass="mr-2 rounded"
            icon="mdi-file-document"
            iconClass=""
          >
          </WarningButton>
        </template>
        <span>Documents</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
export default {
  methods: {
    vehicleStatusChanged() {
      this.params.context.parentComponent.openVehicleStatusUpdate(
        this.params.data
      );
    },
    editItem() {
      this.$router.push({
        name: "edit-vehicle",
        params: { id: this.params.data.id },
      });
    },
    view() {
      this.params.context.parentComponent.getViewDetail(this.params.data.id);
    },
    addTag() {
      this.params.context.parentComponent.addTagsForVehicle(this.params.data);
    },
    getDocumentList() {
      this.params.context.parentComponent.getDocumentList(this.params.data);
    },
    // view() {
    //   this.$router.push({
    //     path: `/app/client/vehicle/view/${this.params.data.id}`,
    //   });
    // },
  },
};
</script>

<style  scoped>
.switch-font-size i {
  font-size: 29px !important;
}
.switch-font-size button {
  font-size: 29px !important;
}
</style>
